export class WorkspaceMemberRPReasonModel {
    workspaceId: string;
    reviewReason: string;
    memberName: string;
    workspaceMemberId: number;
    memberEmailId: string;    
}
export class ReasonForRPAssignment{
    lowMarginReason: string;
    workspaceMemberRPReasonModelList: WorkspaceMemberRPReasonModel[];
}